import { ADMIN_LINKS } from "../config/panelLinks";

// Where to send an admin who opens a module their assigned role doesn't
// grant — the first module (in Sidebar nav order) they DO have access to,
// so ProtectedRoute never lands them on a blank/403-riddled page. Falls
// back to /admin/no-access only if the role grants literally nothing.
export function getDefaultAdminPath(modules = []) {
  const first = ADMIN_LINKS.find((l) => modules.includes(l.moduleKey));
  return first ? first.to : "/admin/no-access";
}
